import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const AddressFormStyle = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 1.2rem 1.8rem;
  margin: 12px 0;
  position: relative;

  @media only screen and (min-width: ${Variable.desktop}) {
    padding: 1.2rem 11rem 1.2rem 1.8rem;
  }

  .form-title {
    font-size: 1.8rem;
    margin: 0 0 1.8rem;
    font-weight: 600;
  }
  .modal-bg {
    background-color: #0000007a;
    height: 100vh;
    width: 100vw;
    position: sticky;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .modal-content {
    background-color: white;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px;
    width: 100%;
    height: 100%;

    @media only screen and (min-width: ${Variable.mobile}) {
      width: 400px;
      height: auto;
    }

    .modal-body {
      top: calc(50% + 20px);
      transform: translateY(-50%);
      position: absolute;
      margin: 0 auto;
      left: 0;
      right: 0;
      padding: 20px;

      @media only screen and (min-width: ${Variable.mobile}) {
        position: static;
        padding: 12px 0 0;
        transform: none;
      }

      h4 {
        margin-top: 0;
        font-size: 3rem;

        @media only screen and (min-width: ${Variable.mobile}) {
          margin-top: 20px;
        }
      }
    }
  }

  &.addressModal {
    .modal-content {
      top: 0;
      transform: none;

      @media only screen and (min-width: ${Variable.mobile}) {
        top: 30px;
      }
    }
  }
  .default-warning {
    color: ${Variable.congressBlue};
  }
  .make-as-default{
    display: flex;
    align-items: center;
    *{
      cursor: pointer;
    }
    input{
      height: 20px;
      width: 20px;
      margin-right: 8px;
    }
  }
`;

export const AddressItemStyle = styled.div`
  margin-bottom: 12px;
  position: relative;
  border: 0;
  border-radius: 4px;

  label {
    pointer-events: none;
    cursor: text;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 16px;
    color: ${Variable.scorpion};
    transition: all 0.2s ease;
    z-index: 0;
    line-height: initial;
  }
  input {
    &[type="text"],
    &[type="email"] {
      background-color: ${Variable.mystic};
      border: 0;

      &.error-field {
        border: 1px solid ${Variable.milanoRed};

        &.hasValue {
          ~ label {
            top: 6px;
          }
          &.focus {
            ~ label {
              top: 6px;
            }
          }
        }

        &:not(.hasValue) {
          &:focus {
            ~ label {
              top: 6px;
            }
          }
        }

        ~ label {
          top: 37%;
        }
      }
    }
    &:focus,
    &.hasValue {
      ~ label {
        cursor: pointer;
        top: 6px;
        left: 9px;
        font-size: 1.2rem;
        transform: none;
      }
    }
  }
  .hasValue,
  .focused {
    ~ label {
      cursor: pointer;
      top: 6px;
      left: 9px;
      font-size: 1.2rem;
      transform: none;
    }
  }
  .chosenSelect {
    position: absolute;
    top: 0;
    color: #000;
    margin-top: 24px;
    margin-left: 12px;
    z-index: 1;
  }
  .selectInput {
    background-color: transparent;
    z-index: 1;
    cursor: text;
    [class$="-control"] {
      background-color: ${Variable.mystic};
      border: 0;
    }
    [class$="-control"] {
      * {
        margin: 0;
        padding: 0;
      }
      [class$="-ValueContainer"],
      > div {
        &:first-child {
          margin: 0;
          padding: 0;
          background-color: transparent;
          cursor: text;

          padding: 24px 10px 8px;

          [class$="-singleValue"] {
            color: ${Variable.black};
            margin-top: 8px;
            margin-left: 0;

            + [class^="css-"] {
              margin: 0;
              padding: 0;
            }
          }
          // + [class^="css-"] {
          //   margin: 0;
          //   padding: 0;
          // }
        }
        [class$="-IndicatorsContainer"],
        &:nth-child(2) {
          display: none;
        }
      }
    }
    [class$="-placeholder"] {
      display: none;
    }
    [class$="-Input"] {
      margin: 0;
      padding: 0;
    }

    &.editInput {
      [class$="-control"] {
        [class$="-ValueContainer"],
        > div {
          &:first-child {
            [class$="-singleValue"] {
              display: none;
            }
          }
        }
      }
    }
    &.countryTyping {
      ~ .chosenSelect {
        display: none;
      }
    }
    &.countryChanged {
      [class$="-singleValue"] {
        display: none;
      }
    }
  }
  [class$="-menu"] {
    box-shadow: none;
    // [class$="-option"] {
    // }
    [class$="1gl4k7y"],
    [class$="NoOptionsMessage"] {
      &:only-child {
        // display: none;
      }
    }
    [class$="-MenuList"],
    > div {
      padding: 0;
      max-height: 310px;
      > div {
        border-top: 0;
        border-right: 1px solid #ccc;
        border-bottom: 0;
        border-left: 1px solid #ccc;

        &:first-child {
          border-top: 1px solid #ccc;
        }
        &:last-child {
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }

  [class$="NoOptionsMessage"] {
  }
  .error {
    bottom: -10px;
    left: 0;
    font-size: 1.2rem;
    color: ${Variable.milanoRed};
    line-height: 0;
  }
  .addressRegion {
    border-radius: 4px;
    border: 1px solid ${Variable.mystic};
    input {
      text-transform: capitalize;
      bottom: 8px;
      position: absolute;
      border: 1px solid transparent !important;
    }
    &.error-field {
      margin-bottom: 3rem;
      border: 1px solid ${Variable.milanoRed};
    }
    ~ .error {
      position: absolute;
    }
  }
  .selectInput {
    ~ label {
      z-index: 1;
    }
  }
  .tooltip {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    filter: grayscale(1) contrast(0.5) brightness(1.7);
    transition: all 0.1s ease;
    font-size: 0;
    border: 0;
    background: none;

    ~ .tooltip-message {
      display: none;
      width: 100%;
      border: 0.1rem solid ${Variable.alto};
      position: absolute;
      top: 5rem;
      left: 0;
      right: 0;
      background: #fff;
      font-size: 1.2rem;
      padding: 1.2rem 1rem;
      border-radius: 0.4rem;
      z-index: 3;
      box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;

      @media only screen and (min-width: ${Variable.tabletLandscape}) {
        width: 120%;
      }
      @media only screen and (min-width: ${Variable.largeDesktop}) {
        width: 110%;
      }
      @media only screen and (min-width: ${Variable.desktop}) {
        font-size: inherit;
        padding: 1.8rem;
      }

      p {
        margin-bottom: 0;
      }

      .triangle-up {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 15px solid #fff;
        top: -1.2rem;
        right: 2.4rem;
        position: absolute;

        @media only screen and (min-width: ${Variable.tabletLandscape}) {
          right: 10rem;
        }
        @media only screen and (min-width: ${Variable.largeDesktop}) {
          right: 7rem;
        }
      }
    }
    &:hover,
    &:focus {
      filter: none;
      ~ .tooltip-message {
        display: block;
      }
    }
  }
`;

export const AddAddressLineBtnStyle = styled.button`
  color: ${Variable.scienceBlue};
  border: 0;
  background: none;
  cursor: pointer;
  padding: 6px 0 16px;

  &:hover{
    text-decoration: underline;
  }
`;

export const ModalCloseStyle = styled.button`
  background: none;
  border: none;
  padding: 0;
  // float: right;
  cursor: pointer;
  position: absolute;
  right: 2rem;
  top: 2rem;

  img{
    height: 1.8rem;
    width: 1.8rem;
  }
`;
